import React from 'react';
import './VideoSection.css';
import greenBullet from '../../assets/images/green-bullet.svg';

const VideoSection = () => {
  return (
    <section className="video-section">
        <div className="video-header">
          <h2 className="section-label">
            <img src={greenBullet} alt="" className="bullet-image" />
            BAYPINE: HOW WE CREATE VALUE
          </h2>
        </div>
        
        <div className="video-container">
          <iframe 
            src="https://player.vimeo.com/video/771301340" 
            title="BayPine: How We Create Value"
            frameBorder="0" 
            allow="autoplay; fullscreen; picture-in-picture" 
            allowFullScreen
          ></iframe>       
        </div>
        <p className="disclaimer">
          Certain statements herein about BayPine made by David Sorbaro ("Mr. Sorbaro"), the Co-CEO of Mavis, a portfolio company of a fund managed by BayPine, are intended to illustrate his business relationship with BayPine, including with respect to BayPine's facilities as a business partner, rather than BayPine's capabilities or expertise with respect to investment advisory services. Mr. Sorbaro was not compensated in connection with his participation in this video, although he generally receives compensation and investment opportunities in connection with his portfolio company role, and is also an investor in a BayPine-sponsored vehicle and pays no fees in connection with his investment in such vehicle. Such compensation and investments subject participants to potential conflicts of interest in making the statements herein.
        </p>
    </section>
  );
};

export default VideoSection;